import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Image, LI, P, UL } from "../../../../../../AbstractElements";
import { dynamicImage } from "../../../../../../Utils";
import { getUserID } from "../../../../../../services/helper";
import SideHeader from "../Common/SideHeader";
import ContactEdit from "./ContactEdit";

export default function BlockTabPane() {
  const { members, blocked } = useSelector((state) => state.chat);
  const [Contacts, setContacts] = useState([]);
  const current_user_id = getUserID();

  const membersBlocked = members.filter((member) =>
    blocked.some((b) => b === member.id)
  );

  const groupCustomersByName = (customers) => {
    const groupedData = {};
    customers.forEach((customer) => {
      const firstLetter = customer.name.charAt(0).toUpperCase();
      if (!groupedData[firstLetter]) {
        groupedData[firstLetter] = [];
      }
      groupedData[firstLetter].push(customer);
    });

    const result = Object.keys(groupedData)
      .sort()
      .map((letter) => ({
        title: letter,
        child: groupedData[letter],
      }));

    return result;
  };
  useEffect(() => {
    const grouped = groupCustomersByName(membersBlocked);
    setContacts(grouped);
  }, [members, blocked]);
  return (
    <>
      {Contacts.length > 0 ? (
        <div className="contact-wrapper">
          {Contacts.map((data, index) => (
            <Fragment key={index}>
              <P>{data.title}</P>
              <UL className="border-0 simple-list">
                {data.child.map((item, index) => (
                  <LI className="common-space" key={index}>
                    <div className="chat-time">
                      {item?.text ? (
                        <div className={`custom-name bg-light-secondary`}>
                          <P className={`txt-secondary f-w-500`}>
                            {item?.text}
                          </P>
                        </div>
                      ) : (
                        <Image
                          className="img-fluid rounded-circle"
                          src={
                            item?.image
                              ? item?.image
                              : dynamicImage("avtar/3.jpg")
                          }
                          alt="user"
                        />
                      )}
                      <div>
                        <span>{item?.name}</span>
                        <P>{item?.store_name}</P>
                      </div>
                    </div>
                    <ContactEdit className={"ml-auto"} id={item?.id} />
                  </LI>
                ))}
              </UL>
            </Fragment>
          ))}
        </div>
      ) : (
        <div className="text-center">{"No User Present"}</div>
      )}
    </>
  );
}
